import Cookies from 'universal-cookie';
const cookieDomain = process.env.REACT_APP_COOKIE_DOMAIN;

export const LukeAndJennaLandingRedirect = () => {
  const cookies = new Cookies();
  cookies.set('last_landing_rule', '/lukeandjenna', { domain: cookieDomain });
  cookies.set('landing_page', '/lukeandjenna', { domain: cookieDomain });
  window.location = '/';
  return null;
};
